import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlReceita = '/service/contabilidade/dotacao/'

class ExerciciosDotacaoService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    getExercicios() {
        return this.conex.get(urlReceita + 'exercicios/')
    }
}

export default ExerciciosDotacaoService
